/* eslint-disable jsx-a11y/anchor-is-valid */
import { memo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import "../css/review.scss";
import ReviewSuccessAttendee from "../Screens/ReviewSuccessAttendee";
import { useLiveStreamAppContext } from "../ContextStore/Store";
import axios from "axios";
import { CallBackGivenForDismiss } from "../utils/AppUtils";
import { getDeviceInfoDetails } from "../utils/PlatformCheck";
import { AmplitudeAddLog } from "../utils/AppAmplitude";

function HostReviewScreen() {
  const [overAllRating, setOverAllRating] = useState();
  const [valueRating, setValueRating] = useState();
  const [punctualityRating, setPunctualityRating] = useState();
  const [serviceRating, setServiceRating] = useState();
  const [textFeedback, setTextFeedback] = useState("");
  const [photos, setPhotos] = useState([]);
  const [hoveredOverAllRating, setHoveredOverAllRating] = useState(0);
  const [hoveredValueRating, setHoveredValueRating] = useState(0);
  const [hoveredPunctualityRating, setHoveredPunctualityRating] = useState(0);
  const [hoveredServiceRating, setHoveredServiceRating] = useState(0);
  const [reviewPostSuccess, setReviewPostSuccess] = useState(false);
  const navigate = useNavigate();
  const [reviewResponsePending, setreviewResponsePending] = useState();
  const {
    __merchantId,
    __userId,
    appInsightTrack,
    __appConfirmUniqueID,
    role,
    userNameHost,
    setInformationContent, setShowInformationStrip,
    setLoaderAnimation,
    serviceProviderId,
    grp,
    businessURL,
    apiUrlPost
  } = useLiveStreamAppContext();
  const deviceInfoDetails = getDeviceInfoDetails();

  const roleValue =
    role === "Attendee" ? "a" : role === "Presenter" ? "h" : role;
  const reJoinUrl =
    "/livestream/meeting?aid=" +
    __appConfirmUniqueID +
    "&mid=" +
    __merchantId +
    "&uid=" +
    __userId +
    "&role=" +
    roleValue +
    "&grp=" + grp;

  const handleRejoinClick = () => {
    if (navigator.userAgent.indexOf("com.vagaro.customerios") > -1) {
      navigate("/livestream/rejoindismiss");
    } else {
      navigate(reJoinUrl);
      sessionStorage.removeItem("end");
      window.location.reload();
    }
  }

  const headers = {
    "Content-Type": "application/json",
    userId: __userId,
    merchantId: __merchantId
  };

  const handleRatingClick = (type, rating) => {
    if (type === "video") {
      setValueRating(rating);
      setHoveredValueRating(0);
    } else if (type === "overall") {
      setOverAllRating(rating);
      setHoveredOverAllRating(0);
    } else if (type === "punctual") {
      setPunctualityRating(rating);
      setHoveredPunctualityRating(0);
    } else if (type === "service") {
      setServiceRating(rating);
      setHoveredServiceRating(0);
    }
  };
  const handleMouseOver = (type, rating) => {
    if (type === "video") {
      setHoveredValueRating(rating);
    } else if (type === "overall") {
      setHoveredOverAllRating(rating);
    } else if (type === "punctual") {
      setHoveredPunctualityRating(rating);
    } else if (type === "service") {
      setHoveredServiceRating(rating);
    }
  };
  const handleMouseOut = (type) => {
    if (type === "video") {
      setHoveredValueRating(0);
    } else if (type === "overall") {
      setHoveredOverAllRating(0);
    } else if (type === "punctual") {
      setHoveredPunctualityRating(0);
    } else if (type === "service") {
      setHoveredServiceRating(0);
    }
  };

  const submitFeedback = () => {
    // Check for mandatory ratings
    if (
      !overAllRating ||
      !punctualityRating ||
      !valueRating ||
      !serviceRating
    ) {
      setShowInformationStrip(true);
      setInformationContent({
        type: 'warn',
        message: 'All reviews are mandatory.',
      });

      return;
    }
    let sendFeedback = document.getElementById("submitFeedback");
    sendFeedback.classList.add("divDisabled");
    // Start loader animation
    setLoaderAnimation(true);
    const payload = {
      IsFromShopdetail: true,
      ReviewPhotoArray: photos,
      appConfirmUniqueId: __appConfirmUniqueID,
      rnkPunctuality: punctualityRating,
      rnkVenue: overAllRating,
      rnkValue: valueRating,
      rnkService: serviceRating,
      VenueReview: "",
      SPReview: textFeedback,
      sGroup: "", //_vgLiveStream.Model.LiveStreamDetails.CurrentGroupID
      rnkCovid: 0,
      ReviewPoint: null,
      IsCovidBusiness: false,
      serviceProviderId: serviceProviderId
    }
    const reviewInitialize = async () => {
      try {
        const reviewResponse = await axios.post(
          `${apiUrlPost}managelivestreamreview`,
          payload,
          { headers }
        );
        // Dispose or reset sensitive data after use
        payload.IReviewID = null
        payload.IsFromShopdetail = null;
        payload.CboServiceProviderValue = null;
        payload.ReviewPhotoArray = null;
        payload.appConfirmUniqueId = null;
        payload.rnkPunctuality = null;
        payload.rnkVenue = null;
        payload.rnkValue = null;
        payload.rnkService = null;
        payload.VenueReview = null;
        payload.ISPID = null;
        payload.SPReview = null;
        payload.sGroup = null;
        payload.rnkCovid = null;
        payload.ReviewPoint = null;
        payload.IsCovidBusiness = null;

        if (reviewResponse.data.message === "Success") {
          setTimeout(() => {
            setLoaderAnimation(false);
            setreviewResponsePending(reviewResponse.data.data);
            setReviewPostSuccess(true);
          }, 1000)
        }
      } catch (error) {
        console.error("Error in fetching feedback response:", error);
        setShowInformationStrip(true);
        setInformationContent({
          type: 'alert',
          message: error.message,
        });
        appInsightTrack(__merchantId, __userId, "Attendee Review Screen", "", error);
      }
    };
    reviewInitialize().then(() => {
      sendFeedback.classList.remove("divDisabled");
    });
  };

  const funConvertImageToBase64 = async (file) => {
    return new Promise((resolve, reject) => {
      if (!file) {
        reject("No file provided");
        return;
      }

      const reader = new FileReader();
      // Triggered when the file is successfully read
      reader.onload = () => {
        if (reader.result) {
          resolve(reader.result);
        } else {
          reject("FileReader result is empty");
        }
      };
      // Triggered when there's an error reading the file
      reader.onerror = () => {
        reject("Error reading file");
      };
      // Read the file as a data URL (base64 format)
      reader.readAsDataURL(file);
    });
  };
  
  // Function to handle individual image upload
  const handlePhotoUpload = async (event) => {
    // Start loader animation
    setLoaderAnimation(true);
    const file = event.target.files[0]; // Only take the first file
    if (!file) return;

    // If we already have 3 images, prevent adding more
    if (photos.length >= 3) {
      console.warn("You can only upload up to 3 images");
      return;
    }

    // Create an object URL for the uploaded image and add it to photos array
    const base64String = await funConvertImageToBase64(file);
    // Define the image object in the specified format
    const imageObject = {
      ImageInputStream: base64String,
      ImageName: file.name,
      ActionName: "Add",
      Image_Type: "image/png",
    };

    setPhotos([...photos, imageObject]);
    setLoaderAnimation(false);
    event.target.value = null; // Reset file input for further uploads    
  };

  // Function to remove an image from photos array
  const handleDelete = (index) => {
    setPhotos(photos.filter((_, i) => i !== index));
  };

  const handleCloseWindow = () => {
    AmplitudeAddLog(__userId, __merchantId, businessURL, 115, grp, __appConfirmUniqueID);
    setTimeout(() => {
      CallBackGivenForDismiss();
      if (deviceInfoDetails.isMobileApp && !deviceInfoDetails.isAndroid) {
        try {
          window.close();
        } catch (e) {
          appInsightTrack(__merchantId, __userId, "Error Review Screen Dismiss", "", e);
        }
        window.location.href = role === "Presenter" ? 'closewindowpro://closewindowProURL' : 'closewindow://closewindowURL';
      } else {
        window.close();
      }
    }, 1500);
  };

  const handleFileInputClick = () => {
    document.getElementById("imageuploadmobile").click();
  };

  useEffect(() => {
    AmplitudeAddLog(__userId, __merchantId, businessURL, 111, grp, __appConfirmUniqueID);
  }, [__userId])
  return (
    <>
      {!reviewPostSuccess === true ? (
        <>

          <div className="host-review review-wrapper">
            <div className="host-review-wrapper">
              <div
                id="btnRejoinLivestream"
                className="top-header rejoin-btn-top rejoin-mob-view"
              >
                <button
                  className="btn btn-outline-cream btn-rejoin rejoin-btn"
                  title="Rejoin Livestream"
                  // onClick={() => {
                  //   navigate(reJoinUrl);
                  // }}
                  onClick={handleRejoinClick}
                >
                  Rejoin Livestream
                </button>
              </div>
              <div className="center-Review-Screen no-wrap">
                <h5 className="review-title">How was your class with {userNameHost}?</h5>
                <div className="rating-dives">
                  <div className="stars">
                    <div className="your-review-title">*Overall Review:</div>
                    <div className="font-size24">
                      <div className="review-rating" id="dv-audioquality">
                        {[1, 2, 3, 4, 5].map((value) => (
                          <div
                            key={value}
                            className={`rating-symbol glyphicon glyphicon-star ${overAllRating >= value ||
                              hoveredOverAllRating >= value
                              ? "rating-symbol"
                              : "glyphicon-star-empty"
                              }`}
                            onMouseOut={() => handleMouseOut("overall")}
                            onMouseOver={() =>
                              handleMouseOver("overall", value)
                            }
                            onClick={() => handleRatingClick("overall", value)}
                          ></div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="stars">
                    <div className="your-review-title">*Punctuality:</div>
                    <div className="font-size24">
                      <div className="review-rating" id="dv-audioquality">
                        {[1, 2, 3, 4, 5].map((value) => (
                          <div
                            key={value}
                            className={`rating-symbol glyphicon glyphicon-star ${punctualityRating >= value ||
                              hoveredPunctualityRating >= value
                              ? "rating-symbol"
                              : "glyphicon-star-empty"
                              }`}
                            onMouseOut={() => handleMouseOut("punctual")}
                            onMouseOver={() =>
                              handleMouseOver("punctual", value)
                            }
                            onClick={() => handleRatingClick("punctual", value)}
                          ></div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="rating-dives">
                  <div className="stars">
                    <div className="your-review-title">*Value:</div>
                    <div className="font-size24">
                      <div className="review-rating" id="dv-videoqualityhost">
                        {[1, 2, 3, 4, 5].map((value) => (
                          <div
                            key={value}
                            className={`rating-symbol glyphicon glyphicon-star ${valueRating >= value ||
                              hoveredValueRating >= value
                              ? "rating-symbol"
                              : "glyphicon-star-empty"
                              }`}
                            onMouseOut={() => handleMouseOut("video")}
                            onMouseOver={() => handleMouseOver("video", value)}
                            onClick={() => handleRatingClick("video", value)}
                          ></div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="stars">
                    <div className="your-review-title">*Service:</div>
                    <div className="font-size24">
                      <div className="review-rating" id="dv-audioquality">
                        {[1, 2, 3, 4, 5].map((value) => (
                          <div
                            key={value}
                            className={`rating-symbol glyphicon glyphicon-star ${serviceRating >= value ||
                              hoveredServiceRating >= value
                              ? "rating-symbol"
                              : "glyphicon-star-empty"
                              }`}
                            onMouseOut={() => handleMouseOut("service")}
                            onMouseOver={() =>
                              handleMouseOver("service", value)
                            }
                            onClick={() => handleRatingClick("service", value)}
                          ></div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="host-Imp">
                  <div
                    className="lbl-TxtArea"
                    style={{
                      display: "block",
                    }}
                  >
                    <div className="rightReviewCountText">
                      <span>{textFeedback.length}</span>/2500
                    </div>
                    <div className="addphoto-title input-title">
                      Leave a review for instructor(optional):
                    </div>
                    <textarea
                      className="review-text-field w-input inputfixscroll bg-Txt t-height"
                      placeholder="Your review will be posted on the business public page"
                      maxLength="2500"
                      value={textFeedback}
                      onChange={(e) => setTextFeedback(e.target.value)}
                    ></textarea>
                  </div>
                </div>
                <div className="addphoto-reviewProfile">
                  <div className="addphoto-title web-subheading-font">
                    Add up to 3 photos (optional):
                  </div>
                  <div className={`add-reviewbtn-bg ${photos.length >= 3 ? 'review-btn-hide' : ''}`} >
                    <input
                      type="file"
                      className="filetypeinputformobile"
                      id="imageuploadmobile"
                      accept="image/*"
                      // capture="camera"
                      style={{ display: "none" }}
                      onChange={handlePhotoUpload}
                    />

                    <a href="javascript:void(0);"
                      className="reviewaddshareimg blue-button"
                      onClick={handleFileInputClick}>
                      <i className="font-awesome-normal-pro text-inverse"></i>
                      Share Your Look or Result
                    </a>
                  </div>

                </div>
                <div className="reviewProfile-bg">
                  <div
                    className="reviewProfile"
                    style={{
                      display:
                        photos.filter((photo) => photo !== null).length < 3
                          ? "block"
                          : "none",
                    }}
                  >
                    <div className="upload-control-img">

                      <div className="reviewpro-photoIcon font-awesome-light vg-image-icon" aria-hidden="true"></div>
                      <div className="notification-text-other vg-notification-text-other">Drag and drop image here or</div>
                      <div className="fileuprelative vg-fileuprelative">
                        <div className="fileuplink vg-fileuplink" role="link">Choose File</div>
                      </div>
                    </div>

                    <input
                      type="file"
                      className="filetypeinput vg-file-type-input"
                      id="imageUpload"
                      onChange={handlePhotoUpload}
                      accept="image/*"
                    />
                  </div>
                  {photos.map((photo, index) => (
                    <div className="review-editpic" key={index}>
                      <div
                        className="review-gallery-image"
                        style={{ backgroundImage: `url(${photo.ImageInputStream})` }}
                      >
                        {/* Conditionally render the Dropdown if the image exists */}
                        {photo && (
                          <Dropdown className="text-right">
                            <Dropdown.Toggle
                              className="btn-3dot-icon three-dot-menu"
                              id="dropdown-basic2"
                            >
                              <i className="icon font-awesome-normal-pro va-dot-menu"></i>
                            </Dropdown.Toggle>
                            <Dropdown.Menu align="end">
                              <Dropdown.Item
                                onClick={() => handleDelete(index)}
                                className="delete-text"
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        )}
                        <div className="review-gallery-hover-div w-clearfix"></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="ft-btn">
                <button
                  className="cbtn brd-btn dismiss"
                  onClick={handleCloseWindow}
                >
                  <span>Dismiss</span>
                </button>
                <button
                  id="submitFeedback"
                  className="cbtn thm-btn send-feedback"
                  onClick={submitFeedback}
                >
                  <span>Post Review</span>
                </button>
              </div>
            </div>
          </div>
        </>
      ) : (
        <ReviewSuccessAttendee reviewResponsePending={reviewResponsePending} />
      )}
    </>
  );
}
export default memo(HostReviewScreen);